// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type LeadTimeExplanationBannerWidgetsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type LeadTimeExplanationBannerWidgetsQuery = {
    readonly __typename?: 'Query';
    readonly userWidgets: ReadonlyArray<Types.UserDisplayedWidgetClassEnum>;
};

export const LeadTimeExplanationBannerWidgetsDocument = gql`
    query leadTimeExplanationBannerWidgets {
        userWidgets
    }
` as unknown as DocumentNode<
    LeadTimeExplanationBannerWidgetsQuery,
    LeadTimeExplanationBannerWidgetsQueryVariables
>;
